import { createStore } from 'stimulus-store';

/**
 * Store for all rooms in the currently selected area.
 *
 * Populated by the rooms supplier controller when the areaStore changes.
 * Consumers can build lookup maps (e.g. room_id → room_name) from this array.
 *
 * Store States:
 * - []: No area selected, or area has no rooms, or loading in progress
 * - [...]: Rooms loaded for the current area
 */
export const allRoomsStore = createStore({
    name: 'allRoomsStore',
    type: Array,
    initialValue: []
});
